import React from 'react';
import { Button } from '@/components/ui/button';
import { Paperclip } from 'lucide-react';
import type { OtroTramiteRecord } from '../types';

interface ArchivosButtonProps {
  tramite: OtroTramiteRecord;
  onClick: (tramite: OtroTramiteRecord) => void;
  label?: string;
  count?: number;
}

export const ArchivosButton: React.FC<ArchivosButtonProps> = ({
  tramite,
  onClick,
  label = 'Archivos',
  count,
}) => {
  const total = count ?? tramite.archivosCount ?? 0;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => onClick(tramite)}
      className="flex items-center gap-2 text-sm"
    >
      <Paperclip className="h-4 w-4" />
      <span>{label}{total > 0 ? ` (${total})` : ''}</span>
    </Button>
  );
};
